import { FormControl, Input, InputLabel } from "@mui/material";
import { useFormContext } from "react-hook-form";
import noviOperater from "../NoviOperater";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = ({ nazivPolja }: { nazivPolja: string }) => {
  const { register, getValues } = useFormContext();
  const odabraniOperater = getValues("odabraniOperater");

  if (!odabraniOperater && !noviOperater) return null;

  return (
    <FormControl
      fullWidth
      sx={{ mt: 3 }}
      error={!daLiJePoljeValidno(nazivPolja)}
    >
      <InputLabel htmlFor={nazivPolja}>*Naziv operatera</InputLabel>
      <Input {...register(nazivPolja)} />
      <PorukaGreskePolja nazivPolja={nazivPolja} />
    </FormControl>
  );
};

export default Index;
